import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getTeacherTodayEarnings } from "../../../../../store/actions/teacher";
import { formatCurrency } from "../../../../../utils/currency";
import styles from "../styles.module.css";

const YourEarnings = ({ pending, lifetime }) => {
  const dispatch = useDispatch();
  const [teacherEarnings, setTeacherEarnings] = useState(0);

  useEffect(() => {
    const fetchEarnings = async () => {
      const data = await dispatch(getTeacherTodayEarnings());
      if (data?.success) setTeacherEarnings(data.data || 0);
    };
    fetchEarnings();
  }, [dispatch]);

  return (
    <div className={styles.myEarnings}>
      <div className={styles.secondRowHeadings}>Earnings Overview</div>
      <div className={styles.earningsRow}>
        <div className={styles.earningsBlock}>
          <p className={styles.earningsTitle}>Today</p>
          <p className={styles.earningsValue}>{formatCurrency(teacherEarnings || 0)}</p>
        </div>
        <div className={styles.earningsBlock}>
          <p className={styles.earningsTitle}>Lifetime</p>
          <p className={styles.earningsValue}>{formatCurrency(lifetime || 0)}</p>
        </div>
        <div className={styles.earningsBlock}>
          <p className={styles.earningsTitle}>Pending Payouts</p>
          <p className={styles.earningsValue}>{formatCurrency(pending || 0)}</p>
        </div>
      </div>
      <div className={styles.withdrawSection}>
        <div className={styles.withdrawBtn}>Withdraw</div>
      </div>
    </div>
  );
};

export default YourEarnings;
